module.exports = __webpack_public_path__ + "img/logistics.d6a92491.png";